const textInputLabel = {
  group: '',
  queryType: 'textInputLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

// export const inTextInput = {
//   group: '',
//   queryType: 'inTextInput',
//   type: 'value',
//   options: []
// }

const advTextInputLabel = {
  group: '',
  queryType: 'advTextInputLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

const jsonRteTextLabel = {
  group: '',
  queryType: 'jsonRteTextLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

const customFieldJsonLabel = {
  group: '',
  queryType: 'customFieldJsonLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

// const customFieldTextLabel = {
//   group: '',
//   queryType: 'customFieldTextLabel',
//   // nextQuery: 'inTextInput',
//   type: 'key',
//   options: []
// }

// const customFieldNumberLabel = {
//   group: '',
//   queryType: 'customFieldNumberLabel',
//   // nextQuery: 'inNumber',
//   type: 'key',
//   options: []
// }

// const customFieldDateLabel = {
//   group: '',
//   queryType: 'customFieldDateLabel',
//   // nextQuery: 'inDate',
//   type: 'key',
//   options: []
// }

// const customFieldBooleanLabel = {
//   group: '',
//   queryType: 'customFieldBooleanLabel',
//   // nextQuery: 'inBoolean',
//   type: 'key',
//   options: []
// }

// const customFieldFileLabel = {
//   group: '',
//   queryType: 'customFieldFileLabel',
//   // nextQuery: 'inFile',
//   type: 'key',
//   options: []
// }

// export const customFieldReferenceLabel = {
//   group: '',
//   queryType: 'customFieldReferenceLabel',
//   // nextQuery: 'inReference',
//   type: 'key',
//   options: []
// }

const selectLabel = {
  group: '',
  queryType: 'selectLabel',
  // nextQuery: 'inSelect',
  type: 'key',
  options: []
}

export const inSelect = {
  group: '',
  queryType: 'inSelect',
  type: 'value',
  options: []
}

export const numberLabel = {
  group: '',
  queryType: 'numberLabel',
  // nextQuery: 'inNumber',
  type: 'key',
  options: []
}

// export const inNumber = {
//   group: '',
//   queryType: 'inNumber',
//   type: 'value',
//   options: []
// }

export const booleanLabel = {
  group: '',
  queryType: 'booleanLabel',
  // nextQuery: 'inBoolean',
  type: 'key',
  options: []
}

export const inBoolean = {
  group: '',
  queryType: 'booleanLabel',
  type: 'value',
  options: [
    { label: 'true', value: 'true' },
    { label: 'false', value: 'false' }
  ]
}

const dateLabel = {
  group: '',
  queryType: 'dateLabel',
  // nextQuery: 'inDate',
  type: 'key',
  options: []
}

export const fileLabel = {
  group: '',
  queryType: 'fileLabel',
  // nextQuery: 'inFile',
  type: 'key',
  options: []
}

export const inFile = {
  group: '',
  queryType: 'fileLabel',
  type: 'value',
  options: []
}

export const linkLabel = {
  group: '',
  queryType: 'linkLabel',
  // nextQuery: 'inTextInput',
  type: 'key',
  options: []
}

export const referenceLabel = {
  group: '',
  queryType: 'referenceLabel',
  // nextQuery: 'inReference',
  type: 'key',
  options: []
}

export const inReference = {
  group: '',
  queryType: 'referenceLabel',
  type: 'value',
  options: []
}

export const getCtUserDefinedFields = (schema = [], userDefinedFields, parentUid, parentDisplayName) => {
  schema.forEach((schemaObj) => {
    let finalUid = parentUid ? parentUid + '.' + schemaObj.uid : schemaObj.uid
    let label = parentDisplayName ? parentDisplayName + ' / ' + schemaObj.display_name : schemaObj.display_name
    //console.log('label test', label, finalUid)

    const field_metadata = schemaObj.field_metadata || {}

    const { markdown, allow_rich_text, multiline, allow_json_rte, extension } = field_metadata

    if (extension && schemaObj.data_type) {
      const supportedCustomFieldType = ['number', 'isodate', 'text', 'file', 'boolean']
      if (supportedCustomFieldType.includes(schemaObj.data_type)) {
        const fieldByDataType = {
          // number: customFieldNumberLabel,
          // isodate: customFieldDateLabel,
          // text: customFieldTextLabel,
          // file: fileLabel,
          // boolean: customFieldBooleanLabel

          number: numberLabel,
          isodate: dateLabel,
          text: textInputLabel,
          file: fileLabel,
          boolean: booleanLabel
          // json: customFieldJsonLabel
        }

        const customFieldOption = [
          {
            label: schemaObj.display_name,
            value: finalUid,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        userDefinedFields.push({ ...fieldByDataType[schemaObj.data_type], options: customFieldOption })
      } else if (schemaObj.data_type === 'json') {
        const customFieldOption = [
          {
            label: schemaObj.display_name,
            value: finalUid,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        userDefinedFields.push({ ...customFieldJsonLabel, options: customFieldOption })
      } else if (schemaObj.data_type === 'reference') {
        const customFieldOption = [
          {
            label: schemaObj.display_name,
            value: finalUid,
            valueOptions:
              typeof schemaObj.reference_to === 'string' ? [schemaObj.reference_to] : schemaObj.reference_to,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        userDefinedFields.push({ ...referenceLabel, options: customFieldOption })
      }
    } else if (schemaObj.data_type === 'json' && allow_json_rte) {
      const jsonRteOption = [
        {
          label: schemaObj.display_name,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...jsonRteTextLabel, options: jsonRteOption })
    } else if (schemaObj.data_type === 'text') {
      if (markdown || allow_rich_text || multiline) {
        const advTextInputOption = [
          {
            label: schemaObj.display_name,
            value: finalUid,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]

        userDefinedFields.push({ ...advTextInputLabel, options: advTextInputOption })
      } else if (
        schemaObj.display_type === 'dropdown' ||
        schemaObj.display_type === 'radio' ||
        schemaObj.display_type === 'checkbox'
      ) {
        let valueOptions = schemaObj.enum.choices.map((choice) => ({
          label: choice.value,
          value: choice.value
        }))
        let selectLabelOption = [
          {
            label: schemaObj.display_name,
            value: finalUid,
            valueOptions,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        const select = {
          ...selectLabel,
          options: selectLabelOption
        }
        userDefinedFields.push(select)
      } else {
        const textInputOption = [
          {
            label: schemaObj.display_name,
            value: finalUid,
            info: parentUid ? label : `/ ${label}`,
            nestingLevel: label ? label.split('/').length - 1 : 0
          }
        ]
        userDefinedFields.push({ ...textInputLabel, options: textInputOption })
      }
    } else if (schemaObj.data_type === 'number') {
      const numberOption = [
        {
          label: schemaObj.display_name,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...numberLabel, options: numberOption })
    } else if (schemaObj.data_type === 'boolean') {
      const booleanOption = [
        {
          label: schemaObj.display_name,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...booleanLabel, options: booleanOption })
    } else if (schemaObj.data_type === 'isodate') {
      const dateLabelOption = [
        {
          label: schemaObj.display_name,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...dateLabel, options: dateLabelOption })
    } else if (schemaObj.data_type === 'file') {
      let fileLabelOption: any = [
        {
          label: schemaObj.display_name,
          value: finalUid,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...fileLabel, options: fileLabelOption })
    } else if (schemaObj.data_type === 'link') {
      const nestingLevel = label ? label.split('/').length - 1 : 0
      const linkLabelOption = [
        {
          label: 'Title',
          value: `${finalUid}.title`,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: nestingLevel + 1
        },
        {
          label: 'URL',
          value: `${finalUid}.href`,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: nestingLevel + 1
        }
      ]
      userDefinedFields.push({
        ...linkLabel,
        group: schemaObj.display_name,
        options: linkLabelOption,
        nestingLevel
      })
    } else if (schemaObj.data_type === 'reference') {
      const referenceLabelOption = [
        {
          label: schemaObj.display_name,
          value: finalUid,
          valueOptions: typeof schemaObj.reference_to === 'string' ? [schemaObj.reference_to] : schemaObj.reference_to,
          info: parentUid ? label : `/ ${label}`,
          nestingLevel: label ? label.split('/').length - 1 : 0
        }
      ]
      userDefinedFields.push({ ...referenceLabel, options: referenceLabelOption })
    } else if (schemaObj.data_type === 'group') {
      const parentGroup = {
        group: schemaObj.display_name,
        options: [],
        nestingLevel: label ? label.split('/').length - 1 : 0
      }
      userDefinedFields.push(parentGroup)
      getCtUserDefinedFields(schemaObj.schema, userDefinedFields, finalUid, label)
    } else if (schemaObj.data_type === 'global_field') {
      const parentGroup = {
        group: schemaObj.display_name,
        options: [],
        nestingLevel: label ? label.split('/').length - 1 : 0
      }
      userDefinedFields.push(parentGroup)
      getCtUserDefinedFields(schemaObj.schema, userDefinedFields, finalUid, label)
    } else if (schemaObj.data_type === 'blocks') {
      let blockUids = parentUid ? parentUid + '.' + schemaObj.uid : schemaObj.uid
      let blockLabel = parentDisplayName ? parentDisplayName + ' / ' + schemaObj.display_name : schemaObj.display_name

      const parentGroup = {
        group: schemaObj.display_name,
        options: [],
        nestingLevel: label ? label.split('/').length - 1 : 0
      }
      userDefinedFields.push(parentGroup)

      schemaObj.blocks.forEach((block) => {
        let singleBlockUids = blockUids + '.' + block.uid
        let singleBlockLabel = blockLabel + ' / ' + block.title
        const parentGroup = {
          group: block.title,
          options: [],
          nestingLevel: singleBlockLabel ? singleBlockLabel.split('/').length - 1 : 0
        }
        userDefinedFields.push(parentGroup)
        getCtUserDefinedFields(block.schema, userDefinedFields, singleBlockUids, singleBlockLabel)
      })
    }
  })

  return userDefinedFields
}

export let allFieldsExceptUserDefined = [
  'created_by',
  'updated_by',
  '_published_by',
  '_publish_environment',
  'created_at',
  'updated_at',
  '_published_at',
  '_is_draft',
  'locale',
  'tags',
  'uid',
  '_content_type_uid',
  'search',
  'taxonomies',
  //todo enable for title && URL in system fields
  'title',
  'url'
]

export const advance_query_errors = {
  no_conditions: 'Please add a valid condition to search',
  no_cursor_found: 'Content type field cannot be used in parent condition if already used in child condition',
  // userdef_field_error:
  //   'User-defined fields cannot be used if multiple content types or no content type are selected in the parent condition',

  userdef_field_multiCt_error:
    'User-defined fields cannot be used if multiple content types are selected in the parent condition',
  userdef_field_noCt_error:
    'User-defined fields cannot be used if there is  no content type selected in the parent condition'
}

let errorMessage = ''
const setErrorCursorAndCtStatus = (advanceQueryChildren, ct_status, errorCursorObj, ctLength) => {
  for (let child of advanceQueryChildren) {
    child.ct_status = ct_status
    const queryArray = child.queryArray
    const foundCtType = queryArray.find((query) => {
      const { key = [], value = [] } = query
      return value.length && key[0]?.value === '_content_type_uid'
    })

    const checkForUserDefFields = queryArray.find((query) => {
      const { key = [], value = [] } = query
      return value.length && key[0] && !allFieldsExceptUserDefined.includes(key[0].value)
    })

    //todo think if we need to reset err here in else
    if (foundCtType && ctLength) {
      child.error_cursor = child.cursorY
      errorCursorObj.cursor = child.cursorY
      errorMessage = advance_query_errors.no_cursor_found
      child.errorMessage = errorMessage
    } else if (checkForUserDefFields && (ctLength > 1 || !ctLength)) {
      child.error_cursor = child.cursorY
      errorCursorObj.cursor = child.cursorY

      let appropriateErrMsg =
        ctLength > 1 ? advance_query_errors.userdef_field_multiCt_error : advance_query_errors.userdef_field_noCt_error

      errorMessage = appropriateErrMsg
      child.errorMessage = appropriateErrMsg
    } else if ((foundCtType && !ctLength) || (checkForUserDefFields && ctLength === 1)) {
      child.error_cursor = -1
      errorCursorObj.cursor = -1
      errorMessage = ''
      child.errorMessage = ''
    }

    if (child.children.length) {
      setErrorCursorAndCtStatus(child.children, ct_status, errorCursorObj, ctLength)
    }
  }
}

export const updateSelectedContentTypeStatus = ({ queryObject, parentQueryObject = {}, type }: any) => {
  errorMessage = ''
  let ct_status
  const queryArray = queryObject.queryArray
  const selectedContentTypes = queryArray.filter((query) => {
    const { key, value } = query
    if (value.length && key[0].value === '_content_type_uid') {
      return true
    }
    return false
  })

  if (selectedContentTypes.length) {
    if (selectedContentTypes.length === 1) {
      ct_status = {
        isMullti: false,
        ct_uid: selectedContentTypes[0].value[0].value
      }
      queryObject.ct_status = { ...ct_status, show_ct: true }
    } else {
      const ctUids = selectedContentTypes.map((ct) => ct.value[0].value)
      ct_status = {
        isMullti: true,
        ct_uid: ctUids
      }
      queryObject.ct_status = { ...ct_status, show_ct: true }
    }

    let errorCursorObj = { cursor: -1 }
    setErrorCursorAndCtStatus(queryObject.children, ct_status, errorCursorObj, selectedContentTypes.length)

    if (errorCursorObj.cursor >= 0) {
      console.log('here -> error_cursors', errorCursorObj.cursor)
    } else if (queryObject.error_cursor >= 0) {
      queryObject.error_cursor = -1
    }
    //if selectedCt not there, ct status there on object and not on parent object
    //remove ct status for child and check error case
  } else if (!parentQueryObject.ct_status && queryObject.ct_status && typeof queryObject.ct_status === 'object') {
    queryObject.ct_status = ''
    queryObject.error_cursor = -1
    setErrorCursorAndCtStatus(queryObject.children, '', { cursor: -1 }, selectedContentTypes.length)
  } else if (type === 'delete') {
    queryObject.ct_status = ''
    queryObject.error_cursor = -1
    setErrorCursorAndCtStatus(queryObject.children, '', { cursor: -1 }, selectedContentTypes.length)
  }
  return errorMessage
}
